import { render, staticRenderFns } from "./BandsEdit.vue?vue&type=template&id=0d5d7eff&"
import script from "./BandsEdit.vue?vue&type=script&lang=js&"
export * from "./BandsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports